import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        VBreadcrumbs,
        { staticClass: "d-print-none" },
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v(" Home ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(VBreadcrumbsItem, { attrs: { disabled: "" } }, [
            _vm._v(" CoA "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-print-none pb-5" },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between" },
            [
              _c(VBtn, { on: { click: _vm.goBack } }, [_vm._v(" Back ")]),
              _c(VSwitch, {
                staticClass: "my-auto mt-2",
                attrs: {
                  "hide-details": "",
                  dense: "",
                  value: true,
                  label: "Condensed",
                },
                model: {
                  value: _vm.condensePrint,
                  callback: function ($$v) {
                    _vm.condensePrint = $$v
                  },
                  expression: "condensePrint",
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex flex-column justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mx-2",
                      on: {
                        click: function ($event) {
                          return _vm.print()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.printSetting.print")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(VDivider),
        ],
        1
      ),
      _vm.loaded
        ? _c("table", { staticStyle: { width: "100%" } }, [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  [
                    _c("company-letter-head", { staticClass: "pb-5" }),
                    _c(VDivider),
                  ],
                  1
                ),
              ]),
            ]),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "mx-5 d-flex flex-column flex-sm-row print-flex-row flex-space-between",
                    },
                    [
                      _c("div", { staticClass: "mr-auto" }, [
                        _c("table", { staticClass: "cell-spacing" }, [
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v("Document No."),
                            ]),
                            _c("td", [_vm._v(_vm._s(_vm.labResult.averoutN))]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v("Program"),
                            ]),
                            _c("td", [_vm._v(_vm._s(_vm.labResult.program))]),
                          ]),
                          _vm.labResult.sampleName
                            ? _c("tr", [
                                _c("td", { staticClass: "font-weight-bold" }, [
                                  _vm._v("Sample Name"),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " + _vm._s(_vm.labResult.sampleName) + " "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _c("div", { staticClass: "ml-0 ml-md-auto" }, [
                        _c("table", { staticClass: "cell-spacing" }, [
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v("Test Time"),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDateYear")(
                                    _vm.labResult.testTime
                                  )
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v("Technician"),
                            ]),
                            _c("td", [
                              _vm._v(_vm._s(_vm.labResult.technician)),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-bold" }, [
                              _vm._v("Final"),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.labResult.finalTest ? "Yes" : "No")
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "mx-6 mt-8" }, [
                    _c(
                      "table",
                      { class: `table ${_vm.condensePrint ? "table-sm" : ""}` },
                      [
                        _vm._m(0),
                        _c(
                          "tbody",
                          _vm._l(_vm.labResult.elements, function (row, index) {
                            return _c(
                              "tr",
                              {
                                key: row.id,
                                attrs: { "align-content": "center" },
                              },
                              [
                                _c("td", [_vm._v(_vm._s(index + 1) + ".")]),
                                _c("td", [
                                  _vm._v(
                                    " " + _vm._s(row.element.symbol) + " "
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " + _vm._s(row.element.elementName) + " "
                                  ),
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.lessThan ? "<" : "") +
                                      " " +
                                      _vm._s(row.compositionPercent) +
                                      " "
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._m(1),
              _c("tr", [
                _c(
                  "td",
                  [
                    _c("div", { staticStyle: { height: "20px" } }),
                    _c(VDivider),
                  ],
                  1
                ),
              ]),
            ]),
            _c("tfoot", [
              _c("tr", [
                _c("td", [
                  _c("div", { staticClass: "d-flex justify-space-between" }, [
                    _vm.isPanya
                      ? _c("span", [
                          _vm._v(
                            " บันทึก : จัดเก็บในแฟ้มเรียงตามลำดับเลขที่, ระยะเวลาจัดเก็บ 2 ปี, วิธีการทำลายย่อย, ผู้รับผิดชอบ MK "
                          ),
                        ])
                      : _vm._e(),
                    _vm.isPanya
                      ? _c("span", [
                          _vm._v(" FM-MK-01-08 Rev.00 Eff. Date : 04/04/22 "),
                        ])
                      : _vm._e(),
                    !_vm.isPanya
                      ? _c("span", [
                          _vm._v(
                            " แบบฟอร์มใบแจ้งน้ำหนักตะกั่ว F-09-11 ฉบับที่ 03 วันที่บังคับใช้ 14 มิ.ย. 65 "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-end font-weight-light text-caption",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.packaging.printOn",
                              _vm.$options.filters.formatDateYear(_vm.printDate)
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", { staticClass: "font-weight-bold" }, [
      _c("tr", [
        _c("td"),
        _c("td", [_vm._v("Symbol")]),
        _c("td", [_vm._v("Name")]),
        _c("td", [_vm._v("Value")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("td", { attrs: { colspan: "4" } })])
  },
]
render._withStripped = true

export { render, staticRenderFns }